import { useEffect, useRef } from 'react';
import { api } from '../utils/api';
import { getUnsyncedWorkouts, deleteUnsyncedWorkout } from '../utils/offlineDb';

export const useOfflineSync = (token, fetchInitialData) => {
    const isSyncing = useRef(false);

    useEffect(() => {
        const syncOfflineWorkouts = async () => {
            if (!token || !navigator.onLine || isSyncing.current) return;
            
            try {
                const unsynced = await getUnsyncedWorkouts();
                if (unsynced && unsynced.length > 0) {
                    isSyncing.current = true;
                    try {
                        const res = await api.fetch('/workouts/sync', { 
                            method: 'POST', 
                            body: JSON.stringify({ workouts: unsynced }) 
                        }, token);
                        
                        if (res && res.message === 'Sync OK') {
                            for (const workout of unsynced) {
                                await deleteUnsyncedWorkout(workout.id);
                            }
                            fetchInitialData(token);
                        }
                    } catch (err) { 
                        console.error('[Batch Sync] Fout bij opslaan:', err); 
                    } finally {
                        isSyncing.current = false;
                    }
                }
            } catch (error) { console.error('[Sync] Fout bij ophalen kluis:', error); }
        };

        window.addEventListener('online', syncOfflineWorkouts);
        syncOfflineWorkouts();

        return () => window.removeEventListener('online', syncOfflineWorkouts);
    }, [token, fetchInitialData]);
};
